import { useRef } from "react";
import { Helmet } from "react-helmet-async";
import "../styles/hiring-circuit.css";
import "../styles/ai-talent-drive.css";
import "../styles/company-signup.css";
import "../styles/drive-team-join.css";
import JoinFlow from "../components/aiTalentDrive/JoinFlow";
import TalentPoolLive from "../components/aiTalentDrive/TalentPoolLive";
import { API_BASE } from "../components/aiTalentDrive/api";
import useRevealOnScroll from "../components/aiTalentDrive/useRevealOnScroll";
import { trackLead } from "../analytics/track";

/*
 * AI Talent Drive: hiring companies (/ai-talent-drive/hiring-companies)
 *
 * The employer side of the drive, in the same "Broadcast signal" system as
 * /ai-talent-drive (the `td` root class brings its tokens and type): the live
 * talent pool (percentages off candidates' CVs and AI interviews) as a hero
 * headcount plus four bands, then the sign-in form. Nothing else. The form is
 * the same join flow Babblebots hands out as a token link; here it uses
 * the campaign staff flagged for the website, so a work email plus a code
 * is both sign-up and sign-in. No form posts leave the site any more (the
 * Web3Forms + Apps Script sheet of the old page are gone).
 */

export default function AiTalentDriveCompanies() {
  const rootRef = useRef<HTMLElement>(null);
  useRevealOnScroll(rootRef);

  return (
    <main className="hc-root td cs-root" ref={rootRef}>
      <Helmet>
        <title>Hire from the AI Talent Drive | Babblebots</title>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          href="https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wdth,wght@12..96,75..100,200..800&family=DM+Mono:wght@400;500&family=Instrument+Serif:ital@0;1&display=swap"
          rel="stylesheet"
        />
        <noscript>{`<style>.hc-root .hc-fade,.hc-root .hc-stagger>*{opacity:1!important}.cs-line>span{transform:none!important}</style>`}</noscript>
      </Helmet>
      <div className="td-grain" aria-hidden="true" />

      {/* ---------- The pool, live ---------- */}
      <TalentPoolLive apiBase={API_BASE} variant="full" />

      {/* ---------- Sign in / sign up, at the end ---------- */}
      <section className="cs-signin tj-root" id="signin">
        <div className="wrap">
          <JoinFlow
            token="public"
            embedded
            onSuccess={() => trackLead("ai_talent_drive_company", "AI Talent Drive company sign-in")}
          />
          <p className="cs-signin__help">
            Stuck? Write to <a href="mailto:helpme@babblebots.ai">helpme@babblebots.ai</a>.
          </p>
        </div>
      </section>
    </main>
  );
}
